import { AsyncPipe } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatOption } from '@angular/material/core';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';
import { SelectOption } from '@shared/models/shared/select-option.model';
import { Observable, of } from 'rxjs';
import { startWith, switchMap } from 'rxjs/operators';

@Component({
    selector: 'formly-autocomplete-type',
    template: `
  <mat-form-field class="w-full float-left">
    <mat-label>{{props.label}}</mat-label>
    <input
      matInput
      [matAutocomplete]="auto"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [placeholder]="props.placeholder"
      [errorStateMatcher]="errorStateMatcher"
      [required]="props.required"
      />
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="getLabel.bind(this)">
        @for (item of filter | async; track item) {
          <mat-option [value]="item.value" [disabled]="item?.disabled === true">
            {{ item.label }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatFormField, MatLabel, MatInput, MatAutocompleteTrigger, FormsModule, ReactiveFormsModule, FormlyModule, MatAutocomplete, MatOption, AsyncPipe]
})
export class AutocompleteTypeComponent extends FieldType<FieldTypeConfig> implements OnInit {
  filter: Observable<SelectOption[]>;

  ngOnInit() {
    this.filter = this.formControl.valueChanges.pipe(
      startWith(''),
      switchMap((term: string | number | boolean) => {
        if (this.props.options instanceof Observable) {
          const observable = this.props.options as Observable<SelectOption[]>;
          return observable;
        } else {
          const options = (this.props.options as SelectOption[])?.filter((option) => option.label?.toLowerCase()?.includes((term && typeof(term) === 'string') ? term.toLowerCase() : String(term)));
          const isValueMatchWithOption = (this.props.options as SelectOption[])?.filter((option) => option.value === term);
          if (!isValueMatchWithOption?.length && term) {
            this.formControl.setErrors({ requireMatch:true })
          }
          return of(options);
        }
      }),
    );
  }

  getLabel(value: number){
    const options: SelectOption[] = this.props.options as SelectOption[];
    const filtered = options?.find(v => v.value === value);
    return filtered ? filtered.label : '';
  }
}